export default __webpack_public_path__ + "static/media/arduino-outline-blue.e0bdbdbc.png";